import { render } from "./VerifyProviderPage.vue?vue&type=template&id=3184bb94&scoped=true"
import script from "./VerifyProviderPage.vue?vue&type=script&lang=js"
export * from "./VerifyProviderPage.vue?vue&type=script&lang=js"

import "./VerifyProviderPage.vue?vue&type=style&index=0&id=3184bb94&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3184bb94"]])

export default __exports__